(function () {
  function init() {
    if (!document.getElementById('dc-root') || window.__ffInit) return;
    window.__ffInit = true;

    /* ---------- SETTINGS ---------- */
    var PRODUCT_HANDLE = 'femoflora';
    var AFTER_ADD = 'cart';     // 'cart' | 'checkout' | 'stay'
    var DEFAULT_PACK = 0;       // 0 = Pack of 1, 1 = Pack of 2, 2 = Pack of 3, 3 = Pack of 4
    var STICKY_ALWAYS = true;   // true = sticky Add to Cart always visible; false = only after scrolling past the main button
    var OFFER_HTML = '🎁 Extra <strong>₹100 OFF</strong> on Prepaid Orders'; // set to '' to hide the offer strip
    /* ------------------------------ */

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    /* ===== GALLERY ===== */
    (function () {
      var g = document.getElementById('ff-gallery');
      if (!g) return;
      var slides = g.querySelectorAll('.ff-slide');
      var dots = g.querySelectorAll('.ff-dot');
      var i = 0;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.style.opacity = k === i ? '1' : '0';
          s.style.pointerEvents = k === i ? 'auto' : 'none';
        });
        dots.forEach(function (d, k) {
          d.style.background = k === i ? '#134a3c' : 'rgba(19, 74, 60, .25)';
        });
      }
      var prev = g.querySelector('.ff-prev'), next = g.querySelector('.ff-next');
      if (prev) prev.addEventListener('click', function () { show(i - 1); });
      if (next) next.addEventListener('click', function () { show(i + 1); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
      var x0 = null;
      g.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      g.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
        x0 = null;
      });
    })();

    /* ===== PACK SELECTOR (tiles) ===== */
    var packs = document.querySelectorAll('.ff-pack');
    var current = DEFAULT_PACK;
    function setText(id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; }

    function select(n) {
      if (!packs[n]) return;
      current = n;
      packs.forEach(function (p, k) { p.setAttribute('aria-checked', k === n ? 'true' : 'false'); });
      var d = packs[n].dataset;
      setText('ff-price', d.price);
      setText('ff-mrp', d.mrp);
      setText('ff-save', d.save);
      setText('ff-atc-price', d.price);
      setText('ff-sa-pack', d.label || '');
      setText('ff-sa-now', d.price);
      setText('ff-sa-mrp', d.mrp);
    }

    packs.forEach(function (p, k) {
      p.addEventListener('click', function () { select(k); });
      p.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(k); }
      });
    });

    document.querySelectorAll('.ff-final-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        select(parseInt(b.getAttribute('data-pack'), 10));
        var box = document.getElementById('ff-packs');
        if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    select(DEFAULT_PACK);

    /* ===== ADD TO CART ===== */
    var mainBtn = document.getElementById('ff-atc');
    var variantsPromise = null;
    function loadVariants() {
      if (!variantsPromise) {
        variantsPromise = fetch(root + 'products/' + PRODUCT_HANDLE + '.js')
          .then(function (r) {
            if (!r.ok) throw new Error('Product "' + PRODUCT_HANDLE + '" not found.');
            return r.json();
          })
          .then(function (p) { return p.variants; });
      }
      return variantsPromise;
    }

    // Match by capsule count ("Pack Of 30 / 60 / 90 / 120 Capsules"), fall back to position
    function resolveVariantId(k) {
      var fixed = packs[k] && packs[k].getAttribute('data-variant-id');
      if (fixed) return Promise.resolve(fixed);
      return loadVariants().then(function (variants) {
        var caps = new RegExp('\\b' + ((k + 1) * 30) + '\\b');
        var match = variants.filter(function (v) { return caps.test(v.title); })[0] || variants[k];
        if (!match) throw new Error('No matching variant for pack ' + (k + 1) + '.');
        if (!match.available) throw new Error('Sorry, this pack is currently out of stock.');
        return match.id;
      });
    }

    function refreshCartCount() {
      return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var sel = '.cart-count, .cart-count-bubble span, [data-cart-count], #CartCount, .js-cart-count, .header__cart-count';
        document.querySelectorAll(sel).forEach(function (el) { el.textContent = cart.item_count; });
        ['cart:refresh', 'cart:updated', 'cart:build', 'theme:cart:reload'].forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
        });
      });
    }

    var busy = false;
    function setBusy(on) {
      if (!mainBtn) return;
      mainBtn.disabled = on;
      mainBtn.style.opacity = on ? '0.6' : '';
      mainBtn.style.cursor = on ? 'wait' : 'pointer';
    }

    function addToCart() {
      if (busy) return;
      busy = true;
      setBusy(true);
      resolveVariantId(current)
        .then(function (id) {
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          });
        })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
            return data;
          });
        })
        .then(function () {
          if (AFTER_ADD === 'checkout') { window.location.href = root + 'checkout'; return; }
          if (AFTER_ADD === 'cart') { window.location.href = root + 'cart'; return; }
          return refreshCartCount();
        })
        .catch(function (err) { alert(err.message); })
        .then(function () { busy = false; setBusy(false); });
    }

    if (mainBtn) mainBtn.addEventListener('click', addToCart);
    loadVariants().catch(function (e) { console.warn('[FemoFlora]', e.message); });

    /* ===== STICKY BAR ===== */
    (function () {
      var bar = document.getElementById('ff-sticky-atc');
      var barBtn = document.getElementById('ff-sa-btn');
      if (!bar || !mainBtn || !barBtn) return;

      // Offer strip above the sticky Add to Cart + its styles
      if (OFFER_HTML && !bar.querySelector('.ff-sa-offer')) {
        var css = document.createElement('style');
        css.textContent =
          '#ff-sticky-atc .ff-sa-offer{background:#fbe9e8;color:#134a3c;text-align:center;' +
          'font:500 13px/1.3 Poppins,sans-serif;padding:7px 16px;border-bottom:1px solid #f0d4d3}' +
          '#ff-sticky-atc .ff-sa-offer strong{font-weight:700}' +
          '.ff-sticky-spacer{height:116px !important}' +
          '@media (max-width:640px){#ff-sticky-atc .ff-sa-offer{font-size:12px;padding:6px 12px}' +
          '.ff-sticky-spacer{height:104px !important}}';
        document.head.appendChild(css);
        var offer = document.createElement('div');
        offer.className = 'ff-sa-offer';
        offer.innerHTML = OFFER_HTML;
        bar.insertBefore(offer, bar.firstChild);
      }

      function setVisible(on) {
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        barBtn.tabIndex = on ? 0 : -1;
      }
      var ticking = false;
      function check() {
        ticking = false;
        setVisible(STICKY_ALWAYS || mainBtn.getBoundingClientRect().bottom < 0);
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(check); }
      }, { passive: true });
      window.addEventListener('resize', check);
      check();
      barBtn.addEventListener('click', addToCart);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();